import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './authorizedRepresentatives.html?raw';
import _LabelInputBase from '../../../moreCore/UI/_LabelInputBase/_LabelInputBase';

import authorizedRepresentatives_row from './authorizedRepresentatives_row';
import "./authorizedRepresentatives_row";


class authorizedRepresentatives extends compose(_LabelInputBase) {
    templateString: any = template;

    rows_container: HTMLElement;
    addRow_button: HTMLButtonElement;

    maxRowsQuantity: number = 3;

    _value: Array<{ index: number, value: object}> = [];

    allRows: Array<MdsLax<InstanceType<typeof authorizedRepresentatives_row>>> = [];

    createNewRow(): void {
        if (this.allRows && this.allRows.length < this.maxRowsQuantity) {
            let row = new authorizedRepresentatives_row();

            this.allRows.push(row);

            row.on("rowValueChange", lang.hitch(this, function (row) {
                this._onValueChange_row(row);
            }));

            if (this.allRows && this.allRows.length == 1) { // nur beim ersten Row die felder obligatorisch machen

                row.firstName.setMandatory(true);
                row.surname.setMandatory(true);
                row.setMandatoryFields(["firstName", "surname"]);
            }

            row.placeAt(this.rows_container);
        } else {
            alert(this.translations["authorizedRepresentatives_row_maxQuantityReached"]);
        }
    }

    _onValueChange_row(row: MdsLax<InstanceType<typeof authorizedRepresentatives_row>>): void { 

        for (let i = 0; i < this.allRows.length; i++) {
            if (this.allRows[i].id == row.id) {

                if (!this._value.length) {
                    this._value.push({ index: i, value: this.allRows[i].getValue() });
                } else {

                    let foundIt: boolean = false;

                    for (let valueObj of this._value) {
                        if (valueObj.index == i) {
                            foundIt = true;
                            valueObj.value = this.allRows[i].getValue();
                        }
                    }

                    if (foundIt == false) {
                        this._value.push({ index: i, value: this.allRows[i].getValue() });
                    }
                }
            }
        }

        this._onChange();
    }

    validateInput(): boolean {
        let result: boolean = true;
        for (let row of this.allRows) {
            if (row.validateInput() == false) {
                result = false;
            }
        }
        return result;
    }

    getValue(): Array<object> {
        let returnValue: Array<object> = [];

        for (let _valueObj of this._value) {
            returnValue.push(_valueObj.value);
        }

        return returnValue;
    }

    _onChange(): void {
        this.emit("valueChange");
    }

    clearRows(): void {
        if (this.allRows && this.allRows.length) {
            for (let i = 0; i < this.allRows.length; i++) {
                this.allRows[i].destroy();
            } 
        }

        this.allRows = [];
        this.rows_container.innerHTML = null;
    }

    _onClick_addRow_button(): void {

        if (this.allRows.length == 1) {
            if (this.allRows[0].dataCompletnessCheck()) {
                this.createNewRow();
            } else {
                alert("Please fill in the first row correctly")
            }
        } else {
            this.createNewRow();
        }
    }

    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        this.createNewRow();
    }

    startup(): void {
        super.startup.apply(this, arguments as any);
    }
}

export default mdsWidget(authorizedRepresentatives);